import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, InputNumber, Select, message, Typography } from 'antd';
import axios from 'axios';

const { Option } = Select;

const StockAdjust = ({ visible, onCancel, onSuccess, product }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [warehouses, setWarehouses] = useState([]);
    const [currentStock, setCurrentStock] = useState(null);

    useEffect(() => {
        if (visible && product) {
            fetchWarehouses();
            // Also fetch current stock distribution?
            // User just wants to adjust.
            form.resetFields();
            form.setFieldsValue({
                label: 'Manual Adjustment',
                warehouse_id: 1 // Default to first?
            });
        }
    }, [visible, product]);

    const fetchWarehouses = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('/api/inventory/warehouses', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setWarehouses(res.data);
            if (res.data.length > 0) {
                form.setFieldsValue({ warehouse_id: res.data[0].id });
            }
        } catch (error) {
            console.error('Failed to fetch warehouses', error);
        }
    };

    const handleWarehouseChange = async (whId) => {
        // Optional: Fetch stock for this product in this warehouse to show "Current: X"
        if (!product) return;
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`/api/inventory/products/${product.id}/stock`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Response from BFF: { warehouses: { ... } } or raw.
            // Assuming structure from dolibarr (array or object map).
            // Let's assume for now we don't show it or we parse it if standard.
            // Dolibarr /products/:id/stock returns { stock_warehouses: { "ID": { ... } } }
        } catch (e) {
            // ignore
        }
        // Ideally we show "Current Stock in this Warehouse: X"
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/stockmovements', {
                product_id: product.id,
                warehouse_id: values.warehouse_id,
                qty: values.qty,
                label: values.label
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            message.success('Stock adjusted');
            onSuccess();
        } catch (error) {
            console.error(error);
            message.error('Adjustment failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Adjust Stock"
            open={visible}
            onCancel={onCancel}
            onOk={() => form.submit()}
            confirmLoading={loading}
            destroyOnClose
        >
            <div style={{ marginBottom: 16 }}>
                <Typography.Text strong>Product:</Typography.Text> {product?.label} <small>({product?.ref})</small> <br />
                <Typography.Text type="secondary">Global Stock: {product?.stock}</Typography.Text>
            </div>

            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item name="warehouse_id" label="Warehouse" rules={[{ required: true }]}>
                    <Select onChange={handleWarehouseChange}>
                        {warehouses.map(w => (
                            <Option key={w.id} value={w.id}>{w.label}</Option>
                        ))}
                        {warehouses.length === 0 && <Option value={1}>Default (Fallback)</Option>}
                    </Select>
                </Form.Item>

                <Form.Item name="qty" label="Adjustment Quantity (+/-)" rules={[{ required: true }]}>
                    <InputNumber style={{ width: '100%' }} autoFocus placeholder="e.g. 10 or -5" />
                </Form.Item>

                <Form.Item name="label" label="Reason / Label" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default StockAdjust;
